import { useEffect, useRef } from "react";
import sendIcon from "../../assets/icons/send.svg";
import translate from "../../locales";

export default function InputText({
  className,
  onInput,
  prefix,
  capitalizeFirstLetter,
}) {
  const fieldRef = useRef();

  useEffect(() => {
    handleFocus();
  }, []);

  const handleSend = () => {
    onInput(fieldRef.current.value);
    fieldRef.current.value = "";
  };

  const handleFocus = () => {
    fieldRef.current.focus();
  };

  const handleChange = () => {
    // Make sure first letter is capitalized
    if (capitalizeFirstLetter) {
      fieldRef.current.value =
        fieldRef.current.value.charAt(0).toUpperCase() +
        fieldRef.current.value.slice(1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div className={`input-text ${className || ""}`}>
      <div className="input-text-text-wrapper" onClick={handleFocus}>
        <span className="input-text-prefix">{prefix}</span>
        <input
          ref={fieldRef}
          type="text"
          placeholder={translate("youtalk_input_placeholder")}
          className="input-text-field valign-text-middle"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          maxLength={200}
        />
      </div>
      <img
        className="send-icon"
        src={sendIcon}
        alt="send icon"
        onClick={handleSend}
      />
    </div>
  );
}
